module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 1
// module chunks = 66 67